<template>
    <div class="open-music-pop">
        <div class="mask">
            <div class="content">
                <div class="title">簽到</div>
                <div class="desc">每日簽到可以領取積分喔！</div>
                <div class="add-score">
                    <img src="@/assets/SignIn/score.png" alt="" />
                    <div class="score-per-sign">+{{ scorePerSign }}</div>
                </div>
                <div class="accumulation">
                    <div class="label">
                        <img src="@/assets/Stage/score.png" alt="" />
                        <div class="text">累積分數</div>
                    </div>
                    <div class="score">+{{ bonusScore }}</div>
                </div>
                <round-btn
                    shadow-color="rgba(171, 203, 216, 0.5)"
                    background-color="#4683bc"
                    color="#ffffff"
                    font-size="1.5em"
                    max-height="95px"
                    min-height="80px"
                    @click="onInteractive"
                >
                    <div class="button-content">點我簽到</div>
                </round-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import GlobalConfig from '@/config/global';

export default {
    data() {
        return {
            scorePerSign: null,
        };
    },
    created() {
        this.scorePerSign = GlobalConfig.scorePerSign;
    },
    methods: {
        onInteractive() {
            this.$emit('interact');
        },
    },
    computed: {
        ...mapState({
            loginDayCount: (state) => state.loginDayCount,
        }),
        bonusScore() {
            const LOGIN_DAYS = this.loginDayCount || 0;
            return LOGIN_DAYS * this.scorePerSign;
        },
    },
};
</script>

<style lang="scss" scoped>
.open-music-pop {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    .mask {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000000af;
        .content {
            color: #003a5d;
            position: absolute;
            padding: 10px 0 20px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            max-width: 370px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 5px;
            box-shadow: 0 0 10px 0 rgba(0, 152, 201, 0.37);
        }
        .title {
            font-size: 28px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .desc {
            font-size: 18px;
            font-weight: bold;
            padding: 5px 20px;
            border-radius: 18.5px;
            background-color: #cbebff;
        }
        .add-score {
            position: relative;
            height: 200px;
            margin: 20px 0;
            img {
                height: 100%;
            }
            .score-per-sign {
                position: absolute;
                top: 57%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 50px;
            }
        }
        .accumulation {
            margin-bottom: 10px;
            font-size: 16px;
            width: 100%;
            padding: 5px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;

            .label {
                display: flex;
                align-items: center;
                margin-right: 30px;
                img {
                    margin-right: 5px;
                    width: 35px;
                    height: 35px;
                }
            }
            .score {
                color: #56a2e6;
            }
        }
        .button-content {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
